// Disable return types for import functions
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// Directly import Home view for faster rendering of first page
import Home from '@/views/Home.vue';

/** @see https://router.vuejs.org/fr/essentials/navigation.html for help */
export const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/resultat',
		name: 'result',
		component: () => import(
			/* webpackChunkName: "result" */
			'@/views/PharmacyList.vue'
		)
	},
	{
		path: '/mentions-legales',
		name: 'legalNotice',
		component: () => import(
			/* webpackChunkName: "legal-notice" */
			'@/views/LegalNotice.vue'
		)
	},
	{
		path: '/accessibilite',
		name: 'accessibility',
		component: () => import(
			/* webpackChunkName: "accessibility" */
			'@/views/Accessibility.vue'
		)
	},
	{
		path: '/maintenance',
		name: 'maintenance',
		component: () => import(
			/* webpackChunkName: "maintenance" */
			'@/views/Maintenance.vue'
		)
	},
	{
		path: '*', // Everything that doesn't match a route
		name: 'notFound',
		component: () => import(
			/* webpackChunkName: "not-found" */
			'@/views/NotFound.vue'
		)
	}
];
